export enum InventoryEraseMethod {
  "NIST_800-88_CLEAR" = "NIST 800-88 CLEAR",
  "US_DOD_5220.2-M" = "US DOD 5220.2-M",
  "APPLE_IOS_ERASURE" = "APPLE iOS ERASURE",
  FACTORY_RESET = "FACTORY RESET",
}
